import { Box } from '@mui/material';
import React from 'react';

interface MprcRibbonListCardsWrapContainerProps {
    gapWidth?: number;
    flexWrap?: "wrap" | "nowrap";
}

export const MprcRibbonListCardsWrapContainer = ({ gapWidth = 0, flexWrap = "wrap", children }: React.PropsWithChildren & MprcRibbonListCardsWrapContainerProps) => {
    return (
        <Box id="ribbonWrapperContainer" sx={{ display: "flex", gap: gapWidth + "px", flexWrap: flexWrap, textAlign: "left", mb: 1, ml:.5 }}>
            {children}
        </Box>
    );
};

export const MprcRibbonListCardsGridContainer = ({ children }: React.PropsWithChildren & MprcRibbonListCardsWrapContainerProps) => {
    return (
        <Box id="ribbonWrapperGridContainer" sx={{ display: "grid", gap: "16px", gridTemplateColumns: "repeat(auto-fill, 220px)", justifyContent: "space-between", mb: 1 }}>
            {children}
        </Box>
    );
};


export const MprcRibbonListCardsExpandedContainer = ({ children }: React.PropsWithChildren) => {
    return (
        <Box id="ribbonExpandedContainer">
            {children}
        </Box>
    );
};

export const MprcRibbonListCardsPortalContainer = ({ children }: React.PropsWithChildren) => {
    return (
        <Box id="ribbonPortalContainer">
            {children}
        </Box>
    );
};
